module.exports = __webpack_public_path__ + "static/media/industrial-3.35d38072.jpg";